export default "__VITE_ASSET__7f0bbec9__"